export const darkTheme = {
  bg: "#121212", // Very dark gray background
  bgDark: "#1F2429", // Even darker gray background (almost black)
  primary: "#90cea1", // Dark teal accent
  secondary: "#FFD700", // Gold accent
  text_primary: "#FFFFFF", // White text
  text_secondary: "#E0E0E0", // Light gray text
  card: "#29323A", // Dark blue card background
  card_dark: "#1F2429", // Even darker blue card background
  button: "#90cea1", // Dark teal button
};
